export const NAME = 'settings';
export const LEVEL_ONE = 'SettingsComponentReducer';
